import { ISampleMetric } from './sample-metric.interface';

export interface ISampleMetricsResponse {
  ecgData: ISampleMetric[];
  pcgData: ISampleMetric[];
  ppgData: ISampleMetric[];
}
